export const MIN_LENGTH_SEARCH = 3;

export const RESULT_LIMIT_MUNICIPALITY = 30;
